import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import SearchForm from '../common/SearchForm';

class SideBar extends Component {
  sidebarSearch() {
    const { path } = this.props.match;

    if (path === '/search' || path.startsWith('/process/')) {
      return 'sidebar-search';
    }

    return '';
  }
  render() {
    // console.log(this.props.match);
    const { path } = this.props.match;
    return (
      <div className={`col-xs-12 sidebar ${this.sidebarSearch()}`}>
        <div className="idea-logo">
          <a href="https://www.idea.int/" target="_blank">
            <div className="logo" />
          </a>
          {/* <a href="http://constitutionnet.org/" target="_blank">
            <div className="cnet" />
          </a> */}
          <a href="https://peacerep.org/" target="_blank">
            <div className="peace-rep" />
          </a>
        </div>

        {path === '/' ? (
          <div></div>
        ) : path === '/search' ? (
          <div>
            <SearchForm layout="searchResult-search" />
          </div>
        ) : path === '/about' ? (
          <div>
            {/* Render content for the '/about' path */}
          </div>
        ) : (
          <div>
            <SearchForm layout="searchResult" />
          </div>
        )}

      </div>
    );
  }
}

export default withRouter(SideBar);
